import React from 'react';
import { PrintDialog } from '@frontend/assets';
import { useInsuranceEligibilityReportContext } from '../dental-insurance-eligibility-report';
import { PrintableReport } from './printable-report';

type InsuranceReportPrintProps = {
  isPrintDialogVisible: boolean;
  hidePrintDialog: () => void;
};

export const InsuranceReportPrint = React.memo(
  ({ isPrintDialogVisible, hidePrintDialog }: InsuranceReportPrintProps) => {
    const { profileData } = useInsuranceEligibilityReportContext();

    const documentTitle = `${profileData?.firstName ?? ''} ${profileData?.lastName ?? ''}`.trim() + ` Insurance Report`;

    return (
      <PrintDialog
        show={isPrintDialogVisible}
        onClose={hidePrintDialog}
        showBackgroundGraphics
        documentTitle={documentTitle}
      >
        <PrintableReport />
      </PrintDialog>
    );
  }
);

InsuranceReportPrint.displayName = 'InsuranceReportPrint';
